export default {
    maxChars: 215,
    minNumberCourses: 6
}